import { OpenInNew } from '@mui/icons-material';
import { Stack, Box, Typography, Divider } from '@mui/material';

import { LinkButton } from 'components';
import { formatPercent } from 'helpers';

export const PieChartLegend = (props: any) => {
  const { payload } = props;
  const subHeader = (header: string) => {
    switch (header) {
      case 'SUBMITTED':
        return 'Total number of candidates who have been submitted through the portal in signed tranches.';
      case 'AWAITING ASSIGNMENT':
        return 'Total number of candidates who are eligible for Rabbit review and are not assigned to any organizations.';
      case 'PENDING SIGNATURE':
        return 'Total number of candidates in unsigned but finalized tranches.';
      case 'UNDER REVIEW':
        return 'Total number of candidates who have been assigned to organizations for review, but have not yet been submitted to a tranche.';
      default:
        return '--';
    }
  };

  const linkBack = (header: string) => {
    switch (header) {
      case 'SUBMITTED':
        return '/home/candidate_admin_dashboard/reviewed_candidates?tranche_status=sent_to_state';
      case 'AWAITING ASSIGNMENT':
        return '/home/candidate_admin_dashboard/reviewed_candidates?organizationally_unreviewable=1';
      case 'PENDING SIGNATURE':
        return '/home/candidate_admin_dashboard/reviewed_candidates?tranche_status=signature_pending';
      case 'UNDER REVIEW':
        return '/home/candidate_admin_dashboard/reviewed_candidates?organizationally_unreviewable=0&tranche_id=0';
      default:
        return '--';
    }
  };
  return (
    <Stack spacing={2}>
      {payload?.map((data: any) => {
        return (
          <Box
            key={data.value}
            sx={{
              display: 'flex',
              direction: 'row',
              alignContent: 'center',
              mt: 1,
            }}
          >
            <Box
              sx={{
                color: data.payload.fill,
                fontSize: 12,
                width: 50,
                textAlign: 'center',
              }}
            >
              {data?.payload?.percent
                ? formatPercent(data.payload.percent)
                : '--'}
              <Divider />
              {data.payload.value.toLocaleString('en-US')}
            </Box>
            <Stack sx={{ ml: 1, width: '300px' }}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
              >
                <Typography
                  color={data?.payload?.fill}
                  sx={{ fontWeight: 'bold' }}
                  variant='body2'
                >
                  {data.payload.name}
                </Typography>
                <LinkButton
                  sx={{
                    m: 0,
                    minWidth: '40px',
                    padding: '0px',
                    color: 'black',
                  }}
                  to={linkBack(data.payload.name)}
                >
                  <OpenInNew fontSize='small' />
                </LinkButton>
              </Box>
              <Typography variant='body2'>
                {subHeader(data.payload.name)}
              </Typography>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};
